<template>
  <div class="overflow-x justify-content-center mt-5">
      <div class=" p-list-representation-table-main">
        <table class="table table-bordered p-table">
            <thead>
              <tr>
                <th >عنوان</th>
                <th >عکس</th>
                <th ></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in tableData" :key="data.id">
                <td>{{data.title}}</td>
                <td>
                  <div class="p-table-img-main d-flex justify-content-center">
                    <img class="p-table-img-item" :src="data.url" alt="">
                  </div>
                </td>
                <td>
                  <div class="row justify-content-center">
                    <button @click="editTableData(data)"  type="button" class="btn btn-primary btn-blue btn-sm btn-table col-3">
                      ویرایش
                    </button>
                  </div>
                </td>

              </tr>


            </tbody>
          </table>
          <div class="d-flex justify-content-center p-table">
            <pagination v-model="valuePage" :per-page="20" :records="500" @paginate="changePage"/>
          </div>
      </div>

  </div>
</template>

<script>


export default {
    name: 'tableContent',
    props: {
      tableData     : { type: [Array, Object], default: [] },
      page          : { type: Number, default: 0 },
    },

    data() {
      return {
        valuePage : 1,
      }
    },

    computed: {

    },

    mounted () {
      this.valuePage = this.page;
    },

    watch: {
      page(data){
        this.valuePage = this.page;
      },


    },

    methods: {
      changePage(page){
        this.$emit('paganationChangePage',page)
      },

      editTableData(data){
        localStorage.setItem("singleGameTabData", JSON.stringify(data));
        this.$router.push({name:'entryAndEditListTabScorersAndKnockoutAndGroup', params:{id:data.id}} )
      },



    },

}
</script>
